/*
 * 帖子列表项用到的两个小工具：首帖内容预览、相对时间。
 *
 * 【前提】首帖正文默认不在列表 API 的响应里，必须在请求时带上
 * include=firstPost（见 index.js 里对 IndexPage.requestParams 的扩展），
 * 否则 discussion.firstPost() 恒为 undefined，预览永远为空。
 */

const excerptCache = {};

function pad(n)
{
    return n < 10 ? '0' + n : String(n);
}

/**
 * 完整时间，用于 title（鼠标悬停/长按可看）。
 */
export function absoluteTime(ts)
{
    const d = new Date(ts);

    return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate())
        + ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes());
}

/**
 * 相对时间：刚刚 / N 分钟前 / N 小时前 / N 天前，超过一周显示月-日。
 */
export function relativeTime(date)
{
    const ts = new Date(date).getTime();

    if (!ts) {
        return '';
    }

    const diff = Date.now() - ts;
    const MIN = 60000;
    const HOUR = 3600000;
    const DAY = 86400000;

    if (diff < MIN) {
        return '刚刚';
    }

    if (diff < HOUR) {
        return Math.floor(diff / MIN) + ' 分钟前';
    }

    if (diff < DAY) {
        return Math.floor(diff / HOUR) + ' 小时前';
    }

    if (diff < 7 * DAY) {
        return Math.floor(diff / DAY) + ' 天前';
    }

    const d = new Date(ts);

    return pad(d.getMonth() + 1) + '-' + pad(d.getDate());
}

/**
 * 取首帖正文的纯文本摘要。
 *
 * 【安全】contentHtml 是服务端渲染过的 HTML，直接 m.trust 插入有风险。
 * 这里用 DOMParser 解析成游离文档、只取 textContent，
 * 结果作为普通文本交给 mithril（自动转义），不会执行任何脚本、也不会加载图片。
 */
export function excerptOf(discussion, max)
{
    if (!discussion) {
        return '';
    }

    const limit = max || 60;
    const id = discussion.id();

    if (excerptCache[id] !== undefined) {
        return excerptCache[id];
    }

    let text = '';

    try {
        const post = typeof discussion.firstPost === 'function' ? discussion.firstPost() : null;
        const html = post && typeof post.contentHtml === 'function' ? post.contentHtml() : '';

        if (html) {
            const doc = new DOMParser().parseFromString(String(html), 'text/html');
            const body = doc && doc.body ? doc.body.textContent : '';
            text = String(body).replace(/\s+/g, ' ').trim();
        }
    } catch (e) {
        text = '';
    }

    if (text.length > limit) {
        text = text.slice(0, limit) + '…';
    }

    excerptCache[id] = text;

    return text;
}
